import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Global "you're in!" celebration that fires once when the user installs
 * the PWA on their phone or desktop. The browser's own install prompt
 * doesn't say anything reassuring, so we follow up with a friendly toast
 * + a one-time `localStorage` flag so the same user never sees it twice.
 *
 * Renders nothing — just listens for the `appinstalled` event globally.
 */
const WELCOMED_KEY = "ccuk_pwa_welcomed_at";

export default function PwaInstallToast() {
  useEffect(() => {
    const onInstalled = () => {
      try {
        if (localStorage.getItem(WELCOMED_KEY)) return;
        localStorage.setItem(WELCOMED_KEY, String(Date.now()));
      } catch {
        /* localStorage may be disabled — celebrate anyway */
      }
      toast.success(
        "You're in! 🏕️ CampCompass is now on your home screen — open it anytime, even off-grid.",
        { duration: 7000, id: "pwa-installed" }
      );
    };
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);

  return null;
}
